import { findIana } from "windows-iana";

// Missing configuration means UTC; unknown/unloaded data is handled by the
// caller, not by substituting the supervisor's browser timezone.
export function resolveLocationTimeZone(value?: string | null): string | null {
	if (!value) return "UTC";
	try {
		new Intl.DateTimeFormat("en", { timeZone: value }).format();
		return value;
	} catch (error) {
		const converted = findIana(value)[0];
		if (!converted) return null;
		try {
			new Intl.DateTimeFormat("en", { timeZone: converted }).format();
			return converted;
		} catch (error) {
			return null;
		}
	}
}

export function locationDateKey(timeZone: string, instant = new Date()): string {
	const parts = new Intl.DateTimeFormat("en-US", {
		timeZone, year: "numeric", month: "2-digit", day: "2-digit",
	}).formatToParts(instant);
	const part = (type: string) => parts.find((item) => item.type === type)?.value;
	return `${part("year")}-${part("month")}-${part("day")}`;
}

// A picked due date (Start / Adjust dates) is stored as the calendar day at
// midnight with no offset; it is already the location's day, so never convert it.
const CALENDAR_DATE = /^\d{4}-\d{2}-\d{2}(?:T00:00(?::00(?:\.0+)?)?)?$/;

export function deadlineDateKey(value: string | null, timeZone: string | null): string | null {
	if (value && CALENDAR_DATE.test(value)) return value.slice(0, 10);
	if (!value || !timeZone) return null;
	const instant = new Date(/(?:Z|[+-]\d{2}:?\d{2})$/i.test(value) ? value : `${value}Z`);
	return Number.isNaN(instant.getTime()) ? null : locationDateKey(timeZone, instant);
}

export function formatLocationDeadline(value: string | null, timeZone: string | null, locale: string): string {
	if (value && CALENDAR_DATE.test(value)) {
		return new Intl.DateTimeFormat(locale, { timeZone: "UTC", year: "numeric", month: "2-digit", day: "2-digit" })
			.format(new Date(`${value.slice(0, 10)}T00:00:00Z`));
	}
	if (!value || !timeZone) return "—";
	// Plan-default due dates are UTC instants, including legacy responses without Z.
	const instant = new Date(/(?:Z|[+-]\d{2}:?\d{2})$/i.test(value) ? value : `${value}Z`);
	if (Number.isNaN(instant.getTime())) return "—";
	return new Intl.DateTimeFormat(locale, { timeZone, year: "numeric", month: "2-digit", day: "2-digit" }).format(instant);
}
